import type React from "react";
import type {DeserializedGridCellParams} from "../../../../../../components/muix-data-grid/MuiXColumnDefinitions.ts";
import type {PartGridGroupModel, PartGridRowModel} from "../CategorizationTableDataModel.ts";
import {Warning} from "@mui/icons-material";
import {SubGroupPaginationCell} from "./SubGroupPaginationCell.tsx";

type Props = DeserializedGridCellParams<PartGridRowModel>;
export const GroupingCell: React.FC<Props> = ({rowNode, formattedValue, row}) => {
    if (rowNode.type === 'leaf') {
        const partRow = row as PartGridRowModel;
        if (partRow.subGroupPagination) {
            return <SubGroupPaginationCell row_id={Number(partRow.supplier_id)}/>;
        }
    } else if (rowNode.type === 'group') {
        // field === GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD
        const groupRow = row as unknown as PartGridGroupModel;
        if (groupRow.hotfixV8DisableInteractions) {
            return <>
                <div className="grouping-toggle-replace-container">
                    <Warning color="primary"/>
                    {/*<Tooltip title="Please refresh to see the latest changes">*/}
                    {/*</Tooltip>*/}
                </div>
                {groupRow.group}
            </>
        }
        return groupRow.group;
    }
    return formattedValue;
}
